// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './translations/en/common.json';
import commonLV from './translations/lv/common.json';
import commonRU from './translations/ru/common.json';
import chatEN from './translations/en/chat.json';
import chatLV from './translations/lv/chat.json';
import chatRU from './translations/ru/chat.json';
import cookieEN from './translations/en/cookie.json';
import cookieLV from './translations/lv/cookie.json';
import cookieRU from './translations/ru/cookie.json';
import privacyEN from './translations/en/privacy.json';
import privacyLV from './translations/lv/privacy.json';
import privacyRU from './translations/ru/privacy.json';
import termsEN from './translations/en/terms.json';
import termsLV from './translations/lv/terms.json';
import termsRU from './translations/ru/terms.json';
import safetyEN from './translations/en/safety.json';
import safetyLV from './translations/lv/safety.json';
import safetyRU from './translations/ru/safety.json';

// Initialize immediately with synchronous loading
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: commonEN, chat: chatEN, cookie: cookieEN, privacy: privacyEN, terms: termsEN, safety: safetyEN },
      lv: { common: commonLV, chat: chatLV, cookie: cookieLV, privacy: privacyLV, terms: termsLV, safety: safetyLV },
      ru: { common: commonRU, chat: chatRU, cookie: cookieRU, privacy: privacyRU, terms: termsRU, safety: safetyRU }
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    
    // Critical options to prevent blocking
    react: {
      useSuspense: false
    },
    
    // Force synchronous initialization 
    initImmediate: false,
    
    // Simplify detection
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    },
    
    interpolation: {
      escapeValue: false
    },
    
    // Enable returning objects and arrays
    returnObjects: true
  });

export default i18n;